module.exports = __webpack_public_path__ + "6d3e6c1c10d43adc75c9e2304d092b67.png";